<template>
  <div id="app" @click="resetSearch">
    <router-view />
    <iframe-kf></iframe-kf>
  </div>
</template>

<script>
import iframeKf from "./components/iframeKf.vue";
export default {
  components: { iframeKf },
  name: "App",
  data() {
    return {};
  },
  created() {
    this.$bus.$on("loadsTop", () => {
      this.loadsTop();
    });
  },
  methods: {
    resetSearch() {
      this.$store.commit("changeSuggest", false);
      this.$store.commit("changeHistory", false);
    },
    loadsTop() {
      const pluginDiv = document.createElement("div");
      pluginDiv.setAttribute("id", "ytWidget");
      pluginDiv.setAttribute("style", "position: fixed;top:50px;z-index:999");
      pluginDiv.async = true;
      document.body.appendChild(pluginDiv);

      const plugin = document.createElement("script");
      plugin.setAttribute(
        "src",
        "https://translate.yandex.net/website-widget/v1/widget.js?widgetId=ytWidget&pageLang=zh&widgetTheme=light&autoMode=false"
      );
      plugin.async = true;
      document.head.appendChild(plugin);
    }
  }
};
</script>

<style>
@import "./assets/css/common.css";
.yt-servicelink {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue